import PropTypes from 'prop-types';
import React from 'react';
import Checkmark from '../../Icons/Checkmark';

import Close from '../../Icons/Close';
import SVGIconWrapper from '../../Icons/SVGIconWrapper/SVGIconWrapper';

import './SortSelect.scss';

export default class SortSelect extends React.PureComponent {
    constructor(props) {
        super(props);
    }

    static propTypes = {
        /**
         * function to close sort dropdown
         */
        onClose: PropTypes.func.isRequired,
        /**
         * array of option objects to sort
         */
        sortOptions: PropTypes.arrayOf(
            PropTypes.shape({
                option: PropTypes.string.isRequired,
                onClick: PropTypes.func.isRequired,
                selected: PropTypes.bool.isRequired,
            })
        ),
        /**
         * boolean to see if dropdown is opened
         */
        isDropdownOpen: PropTypes.bool,
    };

    static defaultProps = {
        sortOptions: [],
        isDropdownOpen: false,
    };

    componentDidMount() {
        document.addEventListener('click', this.handleClickOutside);
    }

    componentWillUnmount() {
        document.removeEventListener('click', this.handleClickOutside);
    }

    setWrapperRef = (node) => {
        this.wrapperRef = node;
    };

    handleClickOutside = (event) => {
        if (
            this.props.isDropdownOpen &&
            this.wrapperRef &&
            !this.wrapperRef.contains(event.target)
        ) {
            this.props.onClose();
        }
    };

    renderOption = ({ option, onClick, selected }, index) => {
        return (
            <li
                key={`option-${index}`}
                className="sort-option"
                onClick={onClick}
            >
                {selected && Checkmark}
                {option}
            </li>
        );
    };

    render() {
        return (
            <ul
                className="component-Resources-SortSelect"
                ref={this.setWrapperRef}
            >
                <li className="sort">
                    Sort by
                    <SVGIconWrapper handleClickSVGWrapper={this.props.onClose}>
                        {Close}
                    </SVGIconWrapper>
                </li>
                {this.props.sortOptions.map(this.renderOption)}
            </ul>
        );
    }
}
